.ju{gap:0.125rem;}